import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import _ from 'lodash';
import AppActions from '../../app/app_actions';
import SwitchButton from '../shared/switchButtonV4.jsx'
import * as agui from 'arm-gui/dist/controls';
import { isNullOrUndefined } from 'util';

import { Utils, UiUtils, NumberFormatter, DateFormatter, i18n, isAuth, opt } from 'arm-common';
import ProdottoActions from './prodotto_actions'



class ConvenzioneCard extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[ConvenzioneCard.jsx] ';
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.validateForm = this.validateForm.bind(this);
        this.onClickSalvaConvenzione = this.onClickSalvaConvenzione.bind(this)
        this.state = {
            validation: new Map(),

        };

    }

    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

    }

    validateForm() {
        console.log(this.componentName + 'validateForm');
        let validation = new Map();
        let required = ['conNome', 'conDescrizione', 'conInizioValidita'];

        for (let i = 0; i < required.length; i++) {

            if (this.props.convenzione[required[i]] === undefined || this.props.convenzione[required[i]] === '' || this.props.convenzione[required[i]] === null) {
                validation.set(required[i], i18n('ARM_CORE_PRODUCT.SHARED.VALORE_OBBLIGATORIO', 'valore obbligatorio'));
            }
        }

        this.setState({ validation: validation });
        if (validation.size === 0) {
            return true;
        }

        let firstKey = validation.keys().next().value;
        $('html, body').animate({
            scrollTop: $("#" + firstKey).offset().top - 70
        }, 1000);
        return false;
    }

    inputChangeHandler(event, id) {
        console.log(this.componentName + "inputChangeHandler");
        if (event !== null && event !== undefined) {
            let parametro;
            let value;
            let type = event.target.type;
            if (id !== undefined && id !== null) {
                parametro = id;
                value = event
            } else {
                parametro = event.target.id;
                value = event.target.value;
            }
            if (type === "date" && value !== undefined) {
                let data = new Date(value);
                value = data.getTime();
            }
            if (this.state.validation.has(parametro)) {
                console.log(this.componentName + "id/par" + parametro);
                this.state.validation.delete(parametro);
            }

            this.props.handleChangeEditConvenzione(this.props.index, parametro, value).then(
            // rivedere currentarget e target se attr mancano da target allora currentarget, altrimenti target è meglio
            resolve =>{

                this.props.validateForm(this.props.index);

            }
            )
        }
    }

    onClickSalvaConvenzione(e) {
        if (this.validateForm()) {
            this.props.onClickSalvaConvenzione(e)
        }
    }


    render() {
        let convenzione = this.props.convenzione;
        let isConvenzioneToEditButton = this.props.isConvenzioneToEditButton;
        let disabled = this.props.disabled;
        return (
            <div className="mt-1 mb-1">

                <agui.Accordion
                    className={"prodottoConvenzione" + this.props.index}
                    disabled={false}
                    loading={false}
                    open={true}
                    marginBottom="12 px"
                >


                    <agui.AccordionHeader
                     className=""
                     open={true}
                     closeIcon="fa fa-chevron-down"
                     openIcon="fa fa-chevron-up"
                    >
                        <div className="mb-3">
                            <div>
                                {this.props.titleCard}

                            </div>
                        </div>
                        </agui.AccordionHeader>

                    <agui.AccordionBody  className="mt-2" >
                        <div className="row">

                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                                <agui.ATextInputV4
                                    id="conNome"
                                    key={"conNome"}
                                    name={"conNome"}
                                    required={true}
                                    validation={this.state.validation}
                                    className="coolTextInput"
                                    label={i18n('ARM_CORE_PRODUCT.CONVENZIONE.NOME', 'Nome')}
                                    disabled={this.props.disabled}
                                    value={convenzione ? convenzione.conNome : null}
                                    onChange={this.inputChangeHandler}
                                />
                            </div>
                            <div className="col-12 col-lg-8 col-md-8 col-sm-12">
                                <agui.ATextInputV4
                                    id="conDescrizione"
                                    key={"conDescrizione"}
                                    name={"conDescrizione"}
                                    required={true}
                                    validation={this.state.validation}
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}
                                    disabled={this.props.disabled}
                                    value={convenzione ? convenzione.conDescrizione : null}
                                    onChange={this.inputChangeHandler}
                                />
                            </div>
                        </div>

                        <div className="row">

                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                                <agui.ATextInputV4
                                    id="conCodiceInterno"
                                    key={"conCodiceInterno"}
                                    name={"conCodiceInterno"}
                                    className="coolTextInput"
                                    label={i18n('ARM_CORE_PRODUCT.CONVENZIONE.CODICE.INTERNO', 'Codice interno')}
                                    disabled={this.props.disabled}
                                    value={convenzione ? convenzione.conCodiceInterno : null}
                                    onChange={this.inputChangeHandler}
                                />
                            </div>
                            {opt("APP", "FL_VIEW_CODICE_COMPAGNIA", "false") === "true" &&
                                <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                                    <agui.ATextInputV4
                                        id="conCodiceCompagnia"
                                        key={"conCodiceCompagnia"}
                                        name={"conCodiceCompagnia"}
                                        className="coolTextInput"
                                        label={i18n('ARM_CORE_PRODUCT.CONVENZIONE.CODICE.INTERNO', 'Codice compagnia')}
                                        disabled={this.props.disabled}
                                        value={convenzione ? convenzione.conCodiceCompagnia : null}
                                        onChange={this.inputChangeHandler}
                                    />
                                </div>
                            }


                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                                <agui.ATextInputV4
                                    id="conCodiceBanca"
                                    key={"conCodiceBanca"}
                                    name={"conCodiceBanca"}
                                    className="coolTextInput"
                                    label={i18n('ARM_CORE_PRODUCT.CONVENZIONE.CODICE.BANCA', 'Codice banca')}
                                    disabled={this.props.disabled}
                                    value={convenzione ? convenzione.conCodiceBanca : null}
                                    onChange={this.inputChangeHandler}
                                />
                            </div>
                        </div>

                        <div className="row">

                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                                <agui.ATextInputV4 id="conInizioValidita" type="date"
                                    value={convenzione.conInizioValidita ? DateFormatter.formatDateFromMilisToString(convenzione.conInizioValidita) : ''}
                                    disabled={this.props.disabled}
                                    required={true}
                                    validation={this.state.validation}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.INIZIO_VALIDITA', 'Inizio Validita')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                                <agui.ATextInputV4 id="conFineValidita" type="date"
                                    value={convenzione.conFineValidita ? DateFormatter.formatDateFromMilisToString(convenzione.conFineValidita) : ''}
                                    disabled={this.props.disabled}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.FINE_VALIDITA', 'Fine Validita')}
                                    onChange={this.inputChangeHandler} />
                            </div>
                            <div className="col-12 col-lg-4 col-md-4 col-sm-12">
                            <agui.ATextInputV4 
                                    id={"ordine"} 
                                    type="number"
                                    value={convenzione.ordine}
                                    validation={this.state.validation}
                                    disabled={this.props.disabled}
                                    name="ordine"
                                    label={i18n('ARM_CORE_PRODUCT.SHARED.POSIZIONE', 'Ordine Visibilità')}
                                    onChange={this.inputChangeHandler} />
                            

                            </div>


                        </div>
                        <div className="row">
                            <div className="col-12 col-lg-6 col-md-6 col-sm-12">
                                <SwitchButton
                                    id="conCostiNonStd"
                                    disabled={this.props.disabled}
                                    label={i18n('ARM_CORE_PRODUCT.PRODOTTO.COSTI.NON.STD', 'Costi non STD')}
                                    value={convenzione.conCostiNonStd}

                                    onChange={this.inputChangeHandler}
                                />
                            </div>
                        </div>

                        </agui.AccordionBody>
                    {
                        (!isConvenzioneToEditButton) ?
                            <div className=" ml-4 mr-4 mb-3">
                                {
                                    (!disabled) ?
                                        <div className='d-flex justify-content-between' >
                                            <agui.aButton bs="secondary" title={i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA_ANULLA', "Annulla modifica")} id={this.props.index} className="float-right" icon="far fa-times-circle" onClick={this.props.onClickAnnullaModifica}></agui.aButton>
                                            <agui.aButton bs="primary" title="Salva Modifiche" id={this.props.index} className="mr-2" icon="fas fa-save" onClick={this.onClickSalvaConvenzione}></agui.aButton>
                                        </div>
                                        :

                                        <div className='d-flex justify-content-between' >

                                            <agui.aButton id={convenzione.idProdottoConvenzione} bs="danger" title={i18n('ARM_CORE_PRODUCT.CONVENZIONE.ELIMINA_CONVENZIONE', "Elimina convenzione")} className="float-right" icon="fas fa-trash-alt" onClick={this.props.onClickEliminaConvenzione}></agui.aButton>
                                            <agui.aButton bs="primary" title={i18n('ARM_CORE_PRODUCT.CONVENZIONE.MODIFICA_CONVENZIONE', "Modifica convenzione")} id={this.props.index} className="mr-2" icon="fas fa-edit" onClick={this.props.onClickModificaConvenzione}></agui.aButton>
                                        </div>

                                }
                            </div>
                            :


                            <div className="d-flex flex-row-reverse">
                                <div className="p-2">
                                    {isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                                        <agui.aButton bs="primary" title={i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', "Modifica")} id={"edit"} className="mr-2" icon="fas fa-edit" onClick={this.props.onClickGestioneConvenzione}>{i18n('ARM_CORE_PRODUCT.SHARED.GESTIONE.Linea', "Gestione")}</agui.aButton>
                                    }
                                </div>
                            </div>
                    }
               </agui.Accordion>
            </div>
        )
    }

}

function mapDispatchToProps(dispatch) {
    return {
        setPathNameToReturn(path) {
            return dispatch(AppActions.setPathNemeToReturn(path));
        },
        handleChangeEditConvenzione(index, parametro, value) {
            return dispatch(ProdottoActions.handleChangeEditConvenzione(index, parametro, value));
        },
    }
}
function mapStateToProps(state) {
    return {
        pathToReturn: state.app.pathNameToReturn,
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvenzioneCard);